import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { apiUtils } from "@/context/query";

export const Route = createFileRoute("/_auth/_app/board/$id")({
  parseParams(params) {
    return z.object({ id: z.coerce.number() }).parse(params);
  },

  loader: async ({ params }) => {
    const accession = await apiUtils.accession.get.fetch(params);
    return { accession };
  },
});
